module.exports = __webpack_public_path__ + "static/media/7.aa99c5ce.gif";